import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import styled from 'styled-components';
import { ButtonSize } from './GoogleLoginButton';

export const Logo = styled.span(({ theme }) => ({
  borderRadius: 2,
  background: theme.colors.highEmphasisWhite,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const Text = styled(Typography).attrs({
  variant: TextStyles['Button'],
})({
  flex: 1,
  whiteSpace: 'nowrap',
  textAlign: 'center',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  height: '100%',
});

export const LoginButton = styled.button<{
  disabled?: boolean;
  size?: Lowercase<ButtonSize>;
}>(({ disabled = false, size }) => ({
  height: size === ButtonSize.LARGE ? 48 : 36,
  width: size === ButtonSize.LARGE ? '100%' : 140,
  padding: 2,
  color: 'white',
  textAlign: 'center',
  backgroundColor: '#5383EC',
  border: 'none',
  boxShadow: '0px 2px 4px 0px rgba(0,0,0,0.25)',
  borderRadius: 4,
  cursor: 'pointer',
  alignItems: 'center',
  display: 'inline-flex',
  textTransform: 'uppercase',
  opacity: disabled ? 0.6 : 1,

  [`${Logo}`]: {
    height: size === ButtonSize.LARGE ? 44 : 32,
    width: size === ButtonSize.LARGE ? 44 : 32,

    img: {
      width: size === ButtonSize.LARGE ? 24 : 20,
      height: size === ButtonSize.LARGE ? 24 : 20,
    },
  },

  [`${Text}`]: {
    padding: size === ButtonSize.LARGE ? '14px 16px' : '8px 12px',
  },
}));
